var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"consumer-metadata-toolbar-container btn-outline-blue w-100",on:{"click":_vm.onClick}},_vm._l((_vm.metadata),function(meta){return _c('div',{key:meta.type,staticClass:"pt-2"},[_c('h5',[_c('i',{class:meta.icon}),_vm._v(" Add New Consumer Field")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }